export type SearchRecord = Record<string, string | string[]>;

/**
 * Query strings keep plain URLSearchParams semantics (`?page=2&tag=a&tag=b`), the URLs the site has
 * always used, instead of TanStack Router's default JSON encoding. Each key is a string, or a string
 * array when repeated; routes coerce types in `validateSearch`.
 */
export const parseSearch = (searchStr: string): SearchRecord => {
  const record: SearchRecord = {};
  for (const [key, value] of new URLSearchParams(searchStr)) {
    const existing = record[key];
    record[key] =
      existing === undefined
        ? value
        : [...(Array.isArray(existing) ? existing : [existing]), value];
  }
  return record;
};

export const stringifySearch = (search: Record<string, unknown>): string => {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(search)) {
    for (const item of Array.isArray(value) ? value : [value]) {
      if (item === undefined || item === null) continue;
      params.append(key, typeof item === "string" ? item : String(item));
    }
  }
  const query = params.toString();
  return query ? `?${query}` : "";
};
